import { HTTPStatusCode } from '../enums/CommonEnums';

export const UKFascias = {
  1: 'cotswold',
  2: 'snowandrock',
  3: 'cyclesurgery',
  4: 'runnersneed',
};

export const HTTPServerErrorCodes = [
  HTTPStatusCode.InternalServerError,
  HTTPStatusCode.NotImplemented,
  HTTPStatusCode.BadGateway,
  HTTPStatusCode.ServiceUnavailable,
  HTTPStatusCode.GatewayTimeout,
  HTTPStatusCode.HTTPVersionNotSupported,
  HTTPStatusCode.VariantAlsoNegotiates,
  HTTPStatusCode.InsufficientStorage,
  HTTPStatusCode.LoopDetected,
  HTTPStatusCode.NotExtended,
  HTTPStatusCode.NetworkAuthenticationRequired,
];
